// frontend/src/pages/AnimationGeneration/InsuranceIcons.js
import React from 'react';
import { 
  AutoInsuranceIcon,
  HomeInsuranceIcon,
  TenantInsuranceIcon,
  PetInsuranceIcon,
  HealthInsuranceIcon,
  TravelInsuranceIcon
} from '../../components/EnhancedInsuranceIcons';
import styles from './InsuranceIcons.module.css';

const InsuranceIcons = () => {
  const insuranceTypes = [
    {
      name: "Auto Insurance",
      description: "Comprehensive coverage for your vehicle with competitive rates and personalized protection.",
      icon: AutoInsuranceIcon,
      iconClass: styles.autoInsurance,
      iconBg: "#e6f0ff"
    },
    {
      name: "Home Insurance",
      description: "Protect your most valuable asset with coverage tailored to your specific home needs.",
      icon: HomeInsuranceIcon,
      iconClass: styles.homeInsurance,
      iconBg: "#fff5eb"
    },
    {
      name: "Tenant Insurance",
      description: "Affordable protection for your belongings and liability coverage for renters.",
      icon: TenantInsuranceIcon,
      iconClass: styles.tenantInsurance,
      iconBg: "#effaf6"
    },
    {
      name: "Pet Insurance",
      description: "Keep your furry friends healthy with coverage for veterinary expenses and treatments.",
      icon: PetInsuranceIcon,
      iconClass: styles.petInsurance,
      iconBg: "#fef7ec"
    },
    {
      name: "Health Insurance",
      description: "Comprehensive health coverage options to keep you and your family protected.",
      icon: HealthInsuranceIcon,
      iconClass: styles.healthInsurance,
      iconBg: "#fdedf0"
    },
    {
      name: "Travel Insurance",
      description: "Travel with peace of mind knowing you're covered for unexpected events worldwide.",
      icon: TravelInsuranceIcon,
      iconClass: styles.travelInsurance,
      iconBg: "#ebf1ff"
    }
  ];
  
  return (
    <section className={styles.insuranceIconsSection}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>3D Insurance Icons</h2>
        <p className={styles.sectionDescription}>
          Interactive representations of our insurance offerings, showcasing Allegory's modern approach to insurance visualization.
        </p>
        
        <div className={styles.iconsGrid}>
          {insuranceTypes.map((insurance, index) => {
            const Icon = insurance.icon;
            return (
              <div key={index} className={`${styles.iconCard} ${insurance.iconClass}`}>
                <div 
                  className={styles.iconWrapper}
                  style={{ background: `linear-gradient(135deg, #ffffff 0%, ${insurance.iconBg} 100%)` }}
                >
                  <Icon size={140} />
                </div>
                <div className={styles.iconContent}>
                  <h3 className={styles.iconTitle}>{insurance.name}</h3>
                  <p className={styles.iconDescription}>{insurance.description}</p>
                </div>
              </div>
            );
          })}
        </div>
        
        <div className={styles.technicalInfo}>
          <h3 className={styles.techTitle}>Technical Implementation</h3>
          <ul className={styles.techList}>
            <li>SVG-based animations for cross-browser compatibility</li>
            <li>Sequenced element animations create a 3D-like appearance</li>
            <li>Responsive design that works across all devices</li>
            <li>Optimized for performance with GPU acceleration</li>
            <li>Accessible and lightweight alternative to WebGL</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default InsuranceIcons;